module.exports = __webpack_public_path__ + "img/newPaintingPav13m.12a19e80.png";